export const COUNTRIES = [
  { code: "BR", name: "f_ei_data_nation_1", phoneCode: "+55" },
  { code: "JP", name: "f_ei_data_nation_4", phoneCode: "+81" },
  { code: "KR", name: "f_ei_data_nation_2", phoneCode: "+82" },
  { code: "US", name: "f_ei_data_nation_3", phoneCode: "+1" },
];
